import { Locale } from './Translation'
import { removeHtmlTags } from './Util'

export type Parent = {
  pageId: string
  path: string
  title: string
  category: string
  image: {
    url: string
    width: number
    height: number
  }
  contents: string
  writer: string | null
  projectName: string | null
}

type rawParent = {
  id: string
  title: string
  parentPage: string
  image: {
    url: string
    width: number
    height: number
  }
  contents: string
  writer: string
  read: string
}
export const convertToParent = (rawParent: rawParent): Parent => ({
  pageId: rawParent.id,
  path: `/${rawParent.parentPage[0]}/${rawParent.id}`,
  title: rawParent.title,
  category: rawParent.parentPage[0],
  image: rawParent.image,
  contents: rawParent.contents,
  writer: rawParent.writer || null,
  projectName: rawParent.read || null,
})

export const convertPlainTitle = (title: string, locale: Locale) =>
  removeHtmlTags(title, {
    brString: locale === 'en' ? ' - ' : ' ',
  })
